import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.4",
  "description": "Turborepo 1.4에는 새로운 예제, 자동 환경 변수 포함 등이 있습니다!",
  "date": "2022/08/09",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.4의 새로운 기능:"
  }, {
    "heading": "",
    "content": "자동 환경 변수 포함: 인기 있는 프레임워크 환경 변수를 자동으로 추론합니다. turbo.json에서 직접 선언할 필요가 없습니다."
  }, {
    "heading": "",
    "content": "eslint-config-turbo: 새로운 ESLint 플러그인으로 향상된 피드백을 제공합니다."
  }, {
    "heading": "",
    "content": "새로운 프레임워크 및 라이브러리 예제: 커뮤니티에서 요청한 새로운 스타터 및 예제입니다."
  }, {
    "heading": "",
    "content": "npm install turbo@latest를 실행하여 오늘 업데이트하세요."
  }, {
    "heading": "자동-환경-변수-포함",
    "content": "환경 전반에 걸쳐 올바른 캐싱을 보장하기 위해 Turborepo는 이제 Astro, Create React App, Gatsby, Next.js, Nuxt, SvelteKit, Vite, Vue 등으로 빌드된 앱의 캐시 키를 계산할 때 공개 환경 변수를 자동으로 추론하고 포함합니다. 수동으로 선언한 경우 turbo.json에서 프레임워크별 공개 환경 변수를 안전하게 제거할 수 있습니다."
  }, {
    "heading": "자동-환경-변수-포함",
    "content": "이 자동 감지 및 포함은 Turborepo가 앱이 빌드된 프레임워크를 성공적으로 추론하는 경우에만 작동합니다. 또한 환경 변수는 해당 프레임워크가 사용되는 워크스페이스의 작업에 대한 캐시 키에만 포함됩니다. 즉, Next.js 앱에 대해 추론된 환경 변수는 Next.js 앱으로 감지된 워크스페이스의 캐시 키에만 포함됩니다. 모노레포의 다른 워크스페이스 작업은 영향을 받지 않습니다."
  }, {
    "heading": "자동-환경-변수-포함",
    "content": "예를 들어, Next.js 프로젝트, Create React App 프로젝트 및 TypeScript 패키지의 세 가지 워크스페이스가 있는 모노레포를 생각해봅시다. 각각 build 스크립트가 있고 두 앱 모두 TypeScript 프로젝트에 의존합니다. 이 Turborepo에 모두 순서대로 빌드하는 표준 turbo.json 파이프라인이 있다고 가정해봅시다:"
  }, {
    "heading": "자동-환경-변수-포함",
    "content": "1.4부터 turbo run build를 실행하면 Turborepo는 TypeScript 패키지를 빌드할 때 빌드 타임 환경 변수를 고려하지 않습니다. 그러나 Next.js 앱을 빌드할 때 Turborepo는 NEXT_PUBLIC_으로 시작하는 환경 변수가 .next 폴더의 출력을 변경할 수 있다고 추론하여 해시 계산 시 포함합니다. 마찬가지로 Create React App의 build 스크립트의 해시를 계산할 때 REACT_APP_PUBLIC_으로 시작하는 모든 빌드 타임 환경 변수가 포함됩니다."
  }, {
    "heading": "자동-환경-변수-포함",
    "content": "프레임워크별 해시 특정성의 이러한 개선은 최적이고 안전하며 정확한 캐싱을 향한 중요한 단계입니다."
  }, {
    "heading": "eslint-config-turbo",
    "content": "Turborepo 캐시가 모든 환경에서 올바르게 공유될 수 있도록 추가적인 편집기 내 지원을 제공하기 위해 새로운 ESLint 설정을 만들었습니다. 새로운 해싱 알고리즘이 대부분의 프레임워크에서 대부분의 상황을 다루어야 하지만, 이 ESLint 설정은 프레임워크 접두사가 없지만 빌드 출력에 영향을 미치는 다른 빌드 타임 인라인 환경 변수를 사용하는 팀과 자동으로 감지할 수 없는 자체 내부 프레임워크를 사용하는 팀에게 편집기 내 피드백을 제공합니다."
  }, {
    "heading": "eslint-config-turbo",
    "content": "시작하려면 루트 eslintrc 파일에서 eslint-config-turbo를 확장하세요:"
  }, {
    "heading": "eslint-config-turbo",
    "content": "규칙에 대한 더 많은 제어를 원하는 경우 - 먼저 플러그인에 추가한 다음 원하는 규칙을 구성하여 eslint-plugin-turbo 플러그인을 직접 설치하고 구성할 수 있습니다:"
  }, {
    "heading": "eslint-config-turbo",
    "content": "이 플러그인은 turbo.json에 선언되지 않은 프레임워크와 관련되지 않은 환경 변수를 코드에서 사용하고 있는 경우 경고합니다."
  }, {
    "heading": "eslint-config-turbo",
    "content": "1.4.x부터 모든 예제와 npx create-turbo를 통해 생성된 새 프로젝트에 eslint-config-turbo를 포함합니다."
  }, {
    "heading": "eslint-config-turbo",
    "content": "ESLint 설정 및 플러그인에 대한 자세한 내용은 ESLint 문서를 참조하세요."
  }, {
    "heading": "새로운-프레임워크-및-라이브러리-예제",
    "content": "여러분의 피드백과 제안을 바탕으로 Turborepo를 워크플로우에 통합하기 위한 새로운 예제를 만들었습니다:"
  }, {
    "heading": "새로운-프레임워크-및-라이브러리-예제",
    "content": "Svelte"
  }, {
    "heading": "새로운-프레임워크-및-라이브러리-예제",
    "content": "Docker"
  }, {
    "heading": "새로운-프레임워크-및-라이브러리-예제",
    "content": "React Native"
  }, {
    "heading": "새로운-프레임워크-및-라이브러리-예제",
    "content": "Prisma"
  }, {
    "heading": "새로운-프레임워크-및-라이브러리-예제",
    "content": "Tailwind"
  }, {
    "heading": "새로운-프레임워크-및-라이브러리-예제",
    "content": "… 그 외 더 많은 예제!"
  }, {
    "heading": "기타-버그-수정-및-개선-사항",
    "content": "git 비교의 양쪽 허용 (#1442)"
  }, {
    "heading": "기타-버그-수정-및-개선-사항",
    "content": "이름 접두사를 공유하는 패키지를 올바르게 재빌드 (#1538)"
  }, {
    "heading": "기타-버그-수정-및-개선-사항",
    "content": "올바른 파일 권한으로 파일 캐시 (#1429)"
  }, {
    "heading": "커뮤니티",
    "content": "6월에 Turborepo v1.3을 출시한 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"
  }, {
    "heading": "커뮤니티",
    "content": "8.65k+ GitHub Stars"
  }, {
    "heading": "커뮤니티",
    "content": "주간 NPM 다운로드 365k, 4월 말 이후 2배 증가"
  }, {
    "heading": "커뮤니티",
    "content": "Vercel의 Remote Caching을 통해 10년의 컴퓨팅 시간 절약, 주당 10개월 절약"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다."
  }, {
    "heading": "커뮤니티",
    "content": "이 릴리스는 다음 분들의 기여로 제공되었습니다: @B2o5T, @chitchu, @elis, @gsoltis, @harshcut, @jaredpalmer, @kocisov, @nathanhammond, @neolivz, @NuroDev, @oneezy, @samouri, @shayc, @StevenMatchett, @tknickman, @trevorr, @zsoldosp 등 더 많은 분들!"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo를 여러분의 선택한 빌드 도구로 만들기 위한 지속적인 지원, 피드백 및 협력에 감사드립니다."
  }],
  "headings": [{
    "id": "자동-환경-변수-포함",
    "content": "자동 환경 변수 포함"
  }, {
    "id": "eslint-config-turbo",
    "content": "eslint-config-turbo"
  }, {
    "id": "새로운-프레임워크-및-라이브러리-예제",
    "content": "새로운 프레임워크 및 라이브러리 예제"
  }, {
    "id": "기타-버그-수정-및-개선-사항",
    "content": "기타 버그 수정 및 개선 사항"
  }, {
    "id": "커뮤니티",
    "content": "커뮤니티"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#자동-환경-변수-포함",
  title: _jsx(_Fragment, {
    children: "자동 환경 변수 포함"
  })
}, {
  depth: 2,
  url: "#eslint-config-turbo",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "eslint-config-turbo"
    })
  })
}, {
  depth: 2,
  url: "#새로운-프레임워크-및-라이브러리-예제",
  title: _jsx(_Fragment, {
    children: "새로운 프레임워크 및 라이브러리 예제"
  })
}, {
  depth: 2,
  url: "#기타-버그-수정-및-개선-사항",
  title: _jsx(_Fragment, {
    children: "기타 버그 수정 및 개선 사항"
  })
}, {
  depth: 2,
  url: "#커뮤니티",
  title: _jsx(_Fragment, {
    children: "커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.4"
    }), "\n", "\n", _jsx(Date, {
      children: "Tuesday, August 9th, 2022"
    }), "\n", _jsx(Authors, {
      authors: ['gregsoltis', 'nathanhammond', 'tomknickman', 'anthonyshew', 'jaredpalmer', 'mehulkar']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 1.4의 새로운 기능:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#automatic-environment-variable-inclusion",
          children: _jsx(_components.strong, {
            children: "자동 환경 변수 포함:"
          })
        }), " 인기 있는 프레임워크 환경 변수를 자동으로 추론합니다. ", _jsx(_components.code, {
          children: "turbo.json"
        }), "에서 직접 선언할 필요가 없습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#eslint-config-turbo",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "eslint-config-turbo"
            }), ":"]
          })
        }), " 새로운 ESLint 플러그인으로 향상된 피드백을 제공합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#new-framework-and-library-examples",
          children: _jsx(_components.strong, {
            children: "새로운 프레임워크 및 라이브러리 예제:"
          })
        }), " 커뮤니티에서 요청한 새로운 스타터 및 예제입니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npm install turbo@latest"
      }), "를 실행하여 오늘 업데이트하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "자동-환경-변수-포함",
      children: "자동 환경 변수 포함"
    }), "\n", _jsxs(_components.p, {
      children: ["환경 전반에 걸쳐 올바른 캐싱을 보장하기 위해 Turborepo는 이제 Astro, Create React App, Gatsby, Next.js, Nuxt, SvelteKit, Vite, Vue 등으로 빌드된 앱의 캐시 키를 계산할 때 공개 환경 변수를 자동으로 추론하고 포함합니다. 수동으로 선언한 경우 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에서 프레임워크별 공개 환경 변수를 안전하게 제거할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  \"pipeline\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    \"build\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      \"dependsOn\": ["
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        \"^build\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-       // Include build time public inlined environment variables that"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-       // are different in development and production, so that"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-       // Turborepo does not use the same cached build"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-       // across environments"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-       \"$NEXT_PUBLIC_EXAMPLE_ENV_VAR\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이 자동 감지 및 포함은 Turborepo가 앱이 빌드된 프레임워크를 성공적으로 추론하는 경우에만 작동합니다. 또한 환경 변수는 해당 프레임워크가 사용되는 워크스페이스의 작업에 대한 캐시 키에만 포함됩니다. 즉, Next.js 앱에 대해 추론된 환경 변수는 Next.js 앱으로 감지된 워크스페이스의 캐시 키에만 포함됩니다. 모노레포의 다른 워크스페이스 작업은 영향을 받지 않습니다."
    }), "\n", _jsxs(_components.p, {
      children: ["예를 들어, Next.js 프로젝트, Create React App 프로젝트 및 TypeScript 패키지의 세 가지 워크스페이스가 있는 모노레포를 생각해봅시다. 각각 ", _jsx(_components.code, {
        children: "build"
      }), " 스크립트가 있고 두 앱 모두 TypeScript 프로젝트에 의존합니다. 이 Turborepo에 모두 순서대로 빌드하는 표준 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 파이프라인이 있다고 가정해봅시다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["1.4부터 ", _jsx(_components.code, {
        children: "turbo run build"
      }), "를 실행하면 Turborepo는 TypeScript 패키지를 빌드할 때 빌드 타임 환경 변수를 고려하지 않습니다. 그러나 Next.js 앱을 빌드할 때 Turborepo는 ", _jsx(_components.code, {
        children: "NEXT_PUBLIC_"
      }), "으로 시작하는 환경 변수가 ", _jsx(_components.code, {
        children: ".next"
      }), " 폴더의 출력을 변경할 수 있다고 추론하여 해시 계산 시 포함합니다. 마찬가지로 Create React App의 ", _jsx(_components.code, {
        children: "build"
      }), " 스크립트의 해시를 계산할 때 ", _jsx(_components.code, {
        children: "REACT_APP_PUBLIC_"
      }), "으로 시작하는 모든 빌드 타임 환경 변수가 포함됩니다."]
    }), "\n", _jsx(_components.p, {
      children: "프레임워크별 해시 특정성의 이러한 개선은 최적이고 안전하며 정확한 캐싱을 향한 중요한 단계입니다."
    }), "\n", _jsx(_components.h2, {
      id: "eslint-config-turbo",
      children: _jsx(_components.code, {
        children: "eslint-config-turbo"
      })
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 캐시가 모든 환경에서 올바르게 공유될 수 있도록 추가적인 편집기 내 지원을 제공하기 위해 새로운 ESLint 설정을 만들었습니다. 새로운 해싱 알고리즘이 대부분의 프레임워크에서 대부분의 상황을 다루어야 하지만, 이 ESLint 설정은 프레임워크 접두사가 없지만 빌드 출력에 영향을 미치는 다른 빌드 타임 인라인 환경 변수를 사용하는 팀과 자동으로 감지할 수 없는 자체 내부 프레임워크를 사용하는 팀에게 편집기 내 피드백을 제공합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["시작하려면 루트 ", _jsx(_components.a, {
        href: "https://eslint.org/docs/latest/user-guide/configuring/configuration-files#configuration-file-formats",
        children: _jsx(_components.code, {
          children: "eslintrc"
        })
      }), " 파일에서 ", _jsx(_components.code, {
        children: "eslint-config-turbo"
      }), "를 확장하세요:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: ".eslint.config.js",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // turbo.json에서 누락된 환경 변수를 자동으로 플래그 지정"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"next/core-web-vitals\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["규칙에 대한 더 많은 제어를 원하는 경우 - 먼저 플러그인에 추가한 다음 원하는 규칙을 구성하여 ", _jsx(_components.code, {
        children: "eslint-plugin-turbo"
      }), " ", _jsx(_components.em, {
        children: "플러그인"
      }), "을 직접 설치하고 구성할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: ".eslint.config.js",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"next/core-web-vitals\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"plugins\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"turbo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"rules\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // turbo.json에서 누락된 환경 변수를 자동으로 플래그 지정"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"turbo/no-undeclared-env-vars\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"error\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 플러그인은 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 선언되지 않은 프레임워크와 관련되지 않은 환경 변수를 코드에서 사용하고 있는 경우 경고합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["1.4.x부터 모든 예제와 ", _jsx(_components.code, {
        children: "npx create-turbo"
      }), "를 통해 생성된 새 프로젝트에 ", _jsx(_components.code, {
        children: "eslint-config-turbo"
      }), "를 포함합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["ESLint 설정 및 플러그인에 대한 자세한 내용은 ", _jsx(_components.a, {
        href: "https://eslint.org/docs/latest/",
        children: "ESLint 문서"
      }), "를 참조하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "새로운-프레임워크-및-라이브러리-예제",
      children: "새로운 프레임워크 및 라이브러리 예제"
    }), "\n", _jsx(_components.p, {
      children: "여러분의 피드백과 제안을 바탕으로 Turborepo를 워크플로우에 통합하기 위한 새로운 예제를 만들었습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/tree/main/examples/with-svelte",
          children: "Svelte"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/tree/main/examples/with-docker",
          children: "Docker"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/tree/main/examples/with-react-native-web",
          children: "React Native"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/tree/main/examples/with-prisma",
          children: "Prisma"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/tree/main/examples/with-tailwind",
          children: "Tailwind"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["… ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/tree/main/examples",
          children: "그 외 더 많은 예제!"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "기타-버그-수정-및-개선-사항",
      children: "기타 버그 수정 및 개선 사항"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["git 비교의 양쪽 허용 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/1442",
          children: "#1442"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["이름 접두사를 공유하는 패키지를 올바르게 재빌드 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/1538",
          children: "#1538"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["올바른 파일 권한으로 파일 캐시 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/1429",
          children: "#1429"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "커뮤니티",
      children: "커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://turborepo.com/blog/turbo-1-3-0",
        children: "6월에 Turborepo v1.3을 출시"
      }), "한 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "8.65k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: "주간 NPM 다운로드 365k, 4월 말 이후 2배 증가"
      }), "\n", _jsx(_components.li, {
        children: "Vercel의 Remote Caching을 통해 10년의 컴퓨팅 시간 절약, 주당 10개월 절약"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다."
    }), "\n", _jsx(_components.p, {
      children: "이 릴리스는 다음 분들의 기여로 제공되었습니다: @B2o5T, @chitchu, @elis, @gsoltis, @harshcut, @jaredpalmer, @kocisov, @nathanhammond, @neolivz, @NuroDev, @oneezy, @samouri, @shayc, @StevenMatchett, @tknickman, @trevorr, @zsoldosp 등 더 많은 분들!"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo를 여러분의 선택한 빌드 도구로 만들기 위한 지속적인 지원, 피드백 및 협력에 감사드립니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
